import {  BaseService, BaseInjector } from '../../node_modules/ui-theme/js/base';
import {
    HeaderElements,
    HeaderSelectors,
    HeaderClassList,
    HeaderTexts
} from '../../node_modules/ui-theme/components/header/scrolling';
import { querySelector } from '../../node_modules/ui-theme/utility/utils';

class Texts extends HeaderTexts {}
class ClassList extends HeaderClassList { 
    sticky = 'position-sticky'
}
class Selectors extends HeaderSelectors {
    disableScrolling = '.disable-scrolling';
    disableHeaderScrolling = '.disable-header-scrolling';
}
class Elements extends HeaderElements {
    disableScrolling: HTMLElement;
    disableHeaderScrolling: HTMLElement;
    constructor(readonly selectors: Selectors) {
        super(selectors);
    }
    initElements() {
        super.initElements();
        this.disableScrolling = querySelector(this.selectors.disableScrolling);
        this.disableHeaderScrolling = querySelector(this.selectors.disableHeaderScrolling);
    }
}

interface Scrolling extends BaseService<Selectors, Elements, ClassList, Texts> {}
@BaseInjector(Selectors, Elements, ClassList, Texts)
class Scrolling {
    adsWrappperHeight: number;
    mainHeaderHeight: number;
    publicationMenuHeight: number;
    get disableScrolling(): boolean {
        return !!this.elements.disableScrolling;
    }
    get disableHeaderScrolling(): boolean {
        return !!this.elements.disableHeaderScrolling;
    }
    initialize() {
        this.setElements();
        this.adsWrappperHeight = this.elements.adsWrappers?.offsetHeight || 0;
        this.mainHeaderHeight = this.elements.header?.offsetHeight || 0;
        this.publicationMenuHeight = this.elements.publicationMenu?.offsetHeight || 0;
        if(this.elements.adsWrappers) this.elements.adsWrappers.style.top = '0';
        if(!this.disableScrolling){
            if(this.disableHeaderScrolling && this.elements.publicationMenu) {
                this.elements.header.classList.remove(this.classList.sticky);
                this.elements.publicationMenu.style.top = `${this.adsWrappperHeight}px`;
            }else {
                this.elements.header.style.top = `${this.adsWrappperHeight}px`;
                if(this.elements.publicationMenu) this.elements.publicationMenu.style.top = `${this.mainHeaderHeight + this.adsWrappperHeight}px`;
            }
        }
        const root = querySelector(':root');
        root.style.setProperty('--totalHeaderHeight', `${this.publicationMenuHeight + this.mainHeaderHeight}px`);
        setTimeout(()=> {
            this.elements.adsWrappers?.classList.remove(this.classList.sticky);
            if(!this.disableScrolling){
                this.elements.header.style.top = '0';
                if(this.elements.publicationMenu) this.elements.publicationMenu.style.top = this.disableHeaderScrolling ? '0' : `${this.mainHeaderHeight}px`;
                if(window.scrollY!==0){
                    let isHeaderInView = this.isElementInViewport(this.elements.header);      
                    if(this.disableHeaderScrolling && this.elements.publicationMenu && !isHeaderInView) {
                        this.elements.headerSideMenu.style.top = '0';
                        this.elements.headerSideMenu.style.maxHeight = 'unset';
                    } else {
                        this.elements.headerSideMenu.style.top = `${this.mainHeaderHeight}px`;
                        this.elements.headerSideMenu.style.maxHeight = `calc(100dvh - ${this.mainHeaderHeight}px)`;
                    }
                }
            }
        }, 5000);

        window.onscroll = () => {
            let isHeaderInView = this.isElementInViewport(this.elements.header);            
            if(this.disableHeaderScrolling && this.elements.publicationMenu && !isHeaderInView) {
                if (this.elements.adsWrappers?.classList.contains(this.classList.sticky)) {
                    this.elements.headerSideMenu.style.top = `${this.adsWrappperHeight}px`;
                    this.elements.headerSideMenu.style.maxHeight = `calc(100dvh - ${this.adsWrappperHeight}px)`;
                } else {
                    this.elements.headerSideMenu.style.top = '0';
                    this.elements.headerSideMenu.style.maxHeight = 'unset';
                }
            } else {
                this.setSideBarTop();
            }
        };

        $(this.selectors.headerSideMenu).on('shown.bs.collapse', e => {
            this.setSideBarTop()
        });
    }
    
    setElements(): void {
        this.elements.setWrapper();
    }
    
    setSideBarTop() {
        const { height: headerHeight, top: headerTop } = this.elements.header.getBoundingClientRect();
        this.elements.headerSideMenu.style.top = `${headerHeight + headerTop}px`;
        this.elements.headerSideMenu.style.maxHeight = `calc(100dvh - ${headerHeight + headerTop}px)`;
    }

    isElementInViewport(element: HTMLElement): boolean {
        const rect = element.getBoundingClientRect();
        return (
            rect.top >= -element.clientHeight &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
        );
    }
}

export default Scrolling;

export {
    Elements as ScrollingElements,
    Selectors as ScrollingSelectors,
    ClassList as ScrollingClassList,
    Texts as ScrollingTexts
}
